export const ORDER_SUBMITTED_TITLE = 'Your order has been submitted!';
export const ORDER_SUBMITTED_SUBTITLE = `Please check your email for a copy of the details. \u000A  A team member will reach out if needed.`;
